import { COUNTRY_IBT, COUNTRY_ISLAND } from '@/constants/internationalBankTransfer'
import { countryIsoCode } from '@/constants/countryCode'
import { countryCodeEnum } from '@/constants/country'
import { sensorsTrack } from '@/util/sensorsdata'
import { SENSORS_TRACK } from '@/util/sensorsdata/constant'

export default {
  data() {
    return {
      eeaCountriesList: [
        countryCodeEnum.AUSTRIA,
        countryCodeEnum.BELGIUM,
        countryCodeEnum.BULGARIA,
        countryCodeEnum.CROATIA,
        countryCodeEnum.CYPRUS,
        countryCodeEnum.CZECH_REPUBLIC,
        countryCodeEnum.DENMARK,
        countryCodeEnum.ESTONIA,
        countryCodeEnum.FINLAND,
        countryCodeEnum.FRANCE,
        countryCodeEnum.GERMANY,
        countryCodeEnum.GREECE,
        countryCodeEnum.HUNGARY,
        countryCodeEnum.ICELAND,
        countryCodeEnum.IRELAND,
        countryCodeEnum.ITALY,
        countryCodeEnum.LATVIA,
        countryCodeEnum.LIECHTENSTEIN,
        countryCodeEnum.LITHUANIA,
        countryCodeEnum.LUXEMBOURG,
        countryCodeEnum.MALTA,
        countryCodeEnum.NETHERLANDS,
        countryCodeEnum.NORWAY,
        countryCodeEnum.POLAND,
        countryCodeEnum.PORTUGAL,
        countryCodeEnum.ROMANIA,
        countryCodeEnum.SLOVAKIA,
        countryCodeEnum.SLOVENIA,
        countryCodeEnum.SPAIN,
        countryCodeEnum.SWEDEN,
      ],
      perfectMoneyCountriesList: [countryCodeEnum.UNITED_STATES, countryCodeEnum.NORTH_KOREA],
      appleGooglePayBlacklist: [
        countryCodeEnum.CHINA,
        countryCodeEnum.BELGIUM,
        countryCodeEnum.CANADA,
        countryCodeEnum.ISRAEL,
        countryCodeEnum.TURKEY,
        countryCodeEnum.UNITED_STATES,
        countryCodeEnum.PUERTO_RICO,
        countryCodeEnum.INDIA,
        countryCodeEnum.CUBA,
        countryCodeEnum.IRAN,
        countryCodeEnum.NORTH_KOREA,
        countryCodeEnum.SUDAN,
        countryCodeEnum.SYRIA,
        countryCodeEnum.IRAQ,
        countryCodeEnum.SOMALIA,
        countryCodeEnum.ITALY,
        countryCodeEnum.SPAIN,
        countryCodeEnum.MALAYSIA,
        countryCodeEnum.AFGHANISTAN,
        countryCodeEnum.FRANCE,
      ],
      EUAllowCountryList: [
        countryCodeEnum.FRANCE,
        countryCodeEnum.AUSTRIA,
        // countryCodeEnum.BELGIUM,
        countryCodeEnum.GERMANY,
        countryCodeEnum.ESTONIA,
        countryCodeEnum.SPAIN,
        countryCodeEnum.HUNGARY,
        countryCodeEnum.ITALY,
        countryCodeEnum.LATVIA,
        countryCodeEnum.LITHUANIA,
        countryCodeEnum.LUXEMBOURG,
        countryCodeEnum.NETHERLANDS,
        countryCodeEnum.POLAND,
        countryCodeEnum.PORTUGAL,
        countryCodeEnum.UNITED_KINGDOM,
      ],
    }
  },
  mounted() {
    this.$store.dispatch('payment/actionRestrictDeposit')
  },
  methods: {
    notRestricted(type, channel = 1) {
      return this.restrictedDeposit === 0 ? true : this.checkRestricted(type, channel)
    },
    checkRestricted(type, channel) {
      let restricted = false

      this.restrictedDeposit.forEach(function (x, y) {
        if (x.paymentType === type && x.paymentChannel === channel) {
          restricted = true
        }
      })

      return !restricted
    },
    creditClick() {
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_PAGE_CLICK, {
        deposit_method: SENSORS_TRACK.DEPOSIT_METHOD.CREDIT_CARD
      });
      this.$router.push({ name: 'creditOrDebit' })
    },
    appleSolidpayClick() {
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_PAGE_CLICK, {
        deposit_method: SENSORS_TRACK.DEPOSIT_METHOD.SOLID_PAYMENT
      });
      this.$router.push({ name: 'appleSolidpay' })
    },
    // appleGooglePayClick() {
    //   this.$router.push({ name: 'appleGooglePay' })
    // },
    // googlePayClick() {
    //   this.$router.push({ name: 'googlePay' })
    // },
    internationalClick() {
      this.$router.push({ name: 'internationalSwift' })
    },
    unionClick() {
      this.$router.push({ name: 'unionPay' })
    },
    chinaUnionClick() {
      this.$router.push({ name: 'unionPayChina' })
    },
    fasapayClick() {
      this.$router.push({ name: 'fasaPay' })
    },
    mobileClick() {
      this.$router.push({ name: 'mobilePay' })
    },
    netellerClick() {
      this.$router.push({ name: 'neteller' })
    },
    skrillClick() {
      this.$router.push({ name: 'skrillPay' })
    },
    vietnamZotapayClick() {
      this.$router.push({ name: 'vietnamZotapay' })
    },
    cryptoClick() {
      this.$router.push({ name: 'Crypto' })
    },
    thailandClick() {
      this.$router.push({ name: 'thailand' })
    },
    canadaLocalBankClick() {
      this.$router.push({ name: 'canadaLocalBank' })
    },
    ukClick() {
      this.$router.push({ name: 'uk' })
    },
    laosClick() {
      this.$router.push({ name: 'laos' })
    },
    malaysiaClick() {
      this.$router.push({ name: 'malaysia' })
    },
    dasshpeUPIClick() {
      this.$router.push({ name: 'upi' })
    },
    indiaClick() {
      this.$router.push({ name: 'india' })
    },
    pagsmileBrazilClick() {
      this.$router.push({ name: 'pagsmileBrazil' })
    },
    pagsmileClick() {
      this.$router.push({ name: 'pagsmile' })
    },
    dasshpeWalletClick() {
      this.$router.push({ name: 'dasshpeWallet' })
    },
    indonesiaClick() {
      this.$router.push({ name: 'indonesia' })
    },
    hongkongClick() {
      this.$router.push({ name: 'hongkong' })
    },
    hongkongQRClick() {
      this.$router.push({ name: 'hongkongQR' })
    },
    philipinessPaymentClick() {
      this.$router.push({ name: 'philipiness' })
    },
    euClick() {
      this.$router.push({ name: 'eu' })
    },
    // nigeriaClick() {
    //   this.$router.push({ name: 'nigeria' })
    // },
    perfectMoneyClick() {
      this.$router.push({ name: 'perfectMoney' })
    },
    // localDepositorClick() {
    //   this.$router.push({ name: 'localdepositor' })
    // },
    indiaBankTransferClick() {
      this.$router.push({ name: 'indiaBankTransfer' })
    },
    myFPXClick() {
      this.$router.push({ name: 'myFPX' })
    },
    myEWalletClick() {
      this.$router.push({ name: 'myEWallet' })
    },
    japanP2PClick() {
      this.$router.push({ name: 'japanP2P' })
    },
    bitwalletClick() {
      this.$router.push({ name: 'bitwalletDeposit' })
    },
    paystackClick() {
      this.$router.push({ name: 'paystackDeposit' })
    },
    iDealClick() {
      this.$router.push({ name: 'iDeal' })
    },
    // payablNetbankingClick() {
    //   this.$router.push({ name: 'payablNetbanking' })
    // },
    japanClick() {
      this.$router.push({ name: 'japan' })
    },
    vietnamBankTransferClick() {
      this.$router.push({ name: 'vietnamBankTransfer' })
    },
    interacClick() {
      this.$router.push({ name: 'interac' })
    },
    // interacGigadatClick() {
    //   this.$router.push({ name: 'interacGigadat' })
    // },
  },
  computed: {
    countryCode() {
      return parseInt(this.$store.state.common.countryCode)
    },
    restrictedDeposit() {
      return this.$store.state.payment.restrictedDeposit
    },
    showIBT() {
      return COUNTRY_IBT.includes(this.countryCode)
    },
    excludePerfectMoneyCountries() {
      return !this.perfectMoneyCountriesList.includes(this.countryCode)
    },
    showAppleGooglePay() {
      return (
        !this.appleGooglePayBlacklist.includes(this.countryCode) &&
        !this.isIsland &&
        this.countryCode !== countryCodeEnum.UNITED_KINGDOM &&
        this.countryCode !== countryCodeEnum.YEMEN &&
        this.countryCode !== countryCodeEnum.SYRIA &&
        this.countryCode !== countryCodeEnum.LEBANON
      )
    },
    showGooglePay() {
      return this.countryCode === countryCodeEnum.UNITED_KINGDOM
    },
    excludeEEACountries() {
      return !this.eeaCountriesList.includes(this.countryCode)
    },
    EUAllowCountryfn() {
      return this.EUAllowCountryList.includes(this.countryCode)
    },
    isIsland() {
      return COUNTRY_ISLAND.includes(this.countryCode)
    },
    getCountryIsoCode() {
      return countryIsoCode.find(c => c.id === parseInt(this.$store.state.common.countryCode)).code
    },
  },
}
